'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _shortid = require('shortid');
var _shortid2 = _interopRequireDefault(_shortid);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var List = function List(props) {
  return _react2.default.createElement('div', {
    className: 'list ' + props.className
  }, props.title ? _react2.default.createElement('h2', {
    className: 'list__title'
  }, props.title) : null, _react2.default.createElement('ul', {
    className: 'list__body ' + (props.numbered ? 'list__body--numbered' : '')
  }, props.items.map(function (item) {
    return _react2.default.createElement('li', {
      className: 'list__item ' + (item.type ? 'list__item--' + item.type : '') + (!item.type && props.numbered ? 'list__item--numbered' : ''),
      dangerouslySetInnerHTML: {
        __html: item.value
      } // eslint-disable-line
      ,
      key: 'list-item-' + _shortid2.default.generate()
    });
  })));
};
List.defaultProps = {
  className: '',
  numbered: false,
  title: ''
};
List.propTypes = {
  className: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  numbered: _propTypes2.default.bool,
  title: _propTypes2.default.string
};
exports.default = List;